<template>
  <v-tile
    ref="tile"
    class="c-tile--trailer"
    :product="product"
  >
    <div
      class="c-tile__wrapper"
      @mouseenter="playTrailer"
      @mouseleave="stopTrailer"
    >
      <v-trailer
        ref="trailer"
        :delay="0"
        :image-type="imageType"
        :product="product"
        mode="tile"
        class="c-tile__trailer"
      ></v-trailer>
      <v-progress
        v-if="$section.tileProgress"
        :product="product"
        class="c-tile__progress"
      ></v-progress>
      <div
        v-if="isProgrammeDisabled"
        class="o-badge c-tile__badge c-tile__badge--left c-tile__badge--locked"
      >
        <i class="o-icon o-icon--lock c-tile__badge-icon"></i>
      </div>
      <v-badge
        :product="product"
        class="c-tile__badge"
        :counting="isPlaying"
      ></v-badge>
    </div>
    <div class="c-tile__details">
      <template v-if="isEpisode">
        <p class="c-tile__subtitle">
          {{ product.title }}
        </p>
        <component
          :is="$section.isUpsellSection ? 'p' : 'h2'"
          class="c-tile__title u-bold"
        >
          {{ product.season.serial.title }}
        </component>
      </template>
      <template v-else>
        <component
          :is="$section.isUpsellSection ? 'p' : 'h2'"
          v-dompurify-html="title"
          :title="product.title"
          class="c-tile__title u-ellipsis-2-lines"
        ></component>
      </template>
      <div class="c-tile__subtitle">
        <i
          v-if="isProgramme"
          class="o-icon o-icon--time o-icon--align-middle"
        ></i>
        {{ subtitle }}
      </div>
    </div>
  </v-tile>
</template>
<script>
  import { VBadge, VProgress, VTile, VTrailer } from '@/index/shared/components';
  import { meta } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { ProductType } from '@/shared/enums';
  import { subtitleKeysMixin } from '../mixins/index';

  export default {
    components: {
      VBadge,
      VProgress,
      VTile,
      VTrailer,
    },
    enums: {
      ProductType,
    },
    filters: {
      meta,
    },
    mixins: [
      productMixin,
      subtitleKeysMixin,
    ],
    inject: ['$section'],
    props: {
      imageType: String,
      product: Object,
    },
    data() {
      return {
        sinceTime: '',
        sinceInterval: 0,
        isPlaying: false,
      };
    },
    computed: {
      isEpisode() {
        return this.product.type === ProductType.EPISODE;
      },
      isProgramme() {
        return this.product.type === ProductType.PROGRAMME;
      },
      isClip() {
        return this.product.type === ProductType.CLIP;
      },
      title() {
        return meta(this.product, 'richTitle');
      },
      subtitle() {
        return meta(this.product, this.subtitleKeys);
      },
    },
    mounted() {
      if (this.isClip) {
        this.getSinceTime();
        this.sinceInterval = setInterval(this.getSinceTime, 1000 * 60);
      }
    },
    beforeDestroy() {
      clearInterval(this.sinceInterval);
    },
    methods: {
      playTrailer() {
        this.$nextTick(() => this.$refs.trailer.play());
        this.isPlaying = true;
      },
      stopTrailer() {
        this.$refs.trailer.stop();
        this.isPlaying = false;
      },
      getSinceTime() {
        this.sinceTime = meta(this.product, 'sinceTime');
      },
    },
  };
</script>
